<template>
  <vl-properties-list v-vl-spacer:bottom.small>
    <vl-properties-label>{{ $t('productgroup.detail.id') }}</vl-properties-label>
    <vl-properties-data>{{ detail.id }}</vl-properties-data>
  </vl-properties-list>
  <ProductGroupFormFields />
</template>

<script lang="ts" setup>
import { computed, onMounted } from 'vue';
import { useForm } from 'vee-validate';
import { useI18n } from 'vue-i18n';
import { ProductGroupDetailDto } from '@/api/backoffice/clients';
import { useProductGroupDetailStore } from '@/modules/configuration/store/product-group/product-group-detail.store';
import { useProductGroupValidations } from './subcomponents/product-group-validations';
import ProductGroupFormFields from './subcomponents/ProductGroupFormFields.vue';

const { t } = useI18n();
const store = useProductGroupDetailStore();

const { validationSchema } = useProductGroupValidations(t);

const { resetForm, handleSubmit } = useForm({
  validationSchema
});

const detail = computed((): ProductGroupDetailDto => {
  return store.detail;
});

onMounted(async () => {
  resetForm({
    values: {
      label: detail.value.label,
      description: detail.value.description,
      emails: detail.value.emails?.map((email) => email.emailAddress) ?? [],
      // The dropdown binds to the definition itself, so the member rows are rebuilt from the
      // definition the detail already carries.
      productProcessDefinitions:
        detail.value.productProcessDefinitions?.map((member) => ({
          productProcessDefinition: member.productProcessDefinition,
          switchDependency: member.switchDependency,          
          dataConnectionCode: member.dataConnectionCode
        })) ?? []
    }
  });
});

const onSuccess = async (values) => {
  await store.update(detail.value.id, {
    label: values.label?.trim(),
    description: values.description?.trim(),
    emails: values.emails?.map((email: string) => email?.trim()),
    productProcessDefinitions: values.productProcessDefinitions?.map((member: any) => ({
      productProcessDefinitionId: member.productProcessDefinition?.id,
      switchDependency: !!member.switchDependency
    }))
  });
};

const onInvalidSubmit = ({ values, errors, results }) => {
  // console.log(values); // current form values
  // console.log(errors); // a map of field names and their first error message
  // console.log(results); // a detailed map of field names and their validation results
};

const onSubmit = handleSubmit(onSuccess, onInvalidSubmit);

defineExpose({ onSubmit });
</script>
